import React from 'react';

export const NappButton = ({ type = "button", style = {}, color = "primary", title = "", size = null, onClick = () => { } }) =>
  <button onClick={onClick} type={type} style={style} className={"button button-" + color + (size ? ' button-' + size : '')}>{title}</button>